module.exports = __webpack_public_path__ + "static/media/shot_200831_115931.37c21cb1.png";